export default "__VITE_ASSET__CKBZ7uQO__"